<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutRowSpaceCenter">
  @if (scenario?.score > 0) {
    <div>
      <h1>
        Score: {{ scenario?.scoreEarned }}/{{ scenario?.score }} ({{
        scenario?.scoreEarned / scenario?.score | percent
        }})
      </h1>
    </div>
  }
  <div>
    <div class="cssLayoutRowCenterCenter">
      <mat-icon
        class="steamfitter-icon"
        svgIcon="ic_crucible_steamfitter"
      ></mat-icon>
      <h2>Tasks</h2>
    </div>
    <table class="task-table">
      <thead>
        <tr>
          <th class="icon-cell">Status</th>
          @if (scenario?.score > 0) {
            <th class="score-cell">Score</th>
          }
          <th class="action-cell">Task</th>
        </tr>
      </thead>
      @for (task of tasks; track task) {
        <tr>
          <td class="icon-cell">
            <mat-icon
              [fontIcon]="statusIcon(task.totalStatus == 'none' ? 'manual' : task.totalStatus)"
              matTooltip="{{ task.totalStatus == 'none' ? 'pending' : task.totalStatus }}"
            ></mat-icon>
          </td>
          @if (scenario?.score > 0) {
            <td class="score-cell">
              @if (task.totalScore > 0) {
                {{ task.totalScoreEarned }}/{{ task.totalScore }}
              }
            </td>
          }
          <td class="action-cell">
            <span [matTooltip]="scenario?.status !== 'active' ? 'Scenario is not active' : !task.executable ? 'This Task cannot be executed again once successful' : task.description">
              <button
                mat-icon-button [attr.aria-label]="'Execute ' + task.name"
                [disabled]="!task.executable || scenario?.status !== 'active'"
                (click)="executeTask(task)"
                >
                <mat-icon fontIcon="mdi-play"></mat-icon>
              </button>
            </span>
            <span matTooltip="{{ task.description }}">{{ task.name }}</span>
          </td>
        </tr>
      }
    </table>
  </div>
</div>
